// extracted by mini-css-extract-plugin
export var card = "related-card-module--card--73141";
export var cardContent = "related-card-module--cardContent--2147f";
export var cardDescription = "related-card-module--cardDescription--f5b2c";
export var cardImage = "related-card-module--cardImage--73d70";
export var cardTitle = "related-card-module--cardTitle--85d29";
export var genericContainer = "related-card-module--genericContainer--4bc9e";